import { combineReducers } from '@reduxjs/toolkit';

import tableReducer from './tableSlice';

export const tableReducers = combineReducers({
  table: tableReducer,
});
